// src/components/spatial/config/drawSpaceConfig.js

const drawSpaceConfig = {
  /*
  ================================================================
  OUTILS DISPONIBLES DANS LA TOOLBAR
  ================================================================
  */
  tools: {
    SELECT: "select",
    AREA_RECT: "area-rect",
    AREA_POLYLINE: "area-polyline",
    LINE: "line",
    CIRCLE: "circle",
    ARC: "arc",
    MOVE: "move",
    COPY: "copy",
    STRETCH: "stretch",
    DELETE: "delete",
    PAN: "pan",
    ZOOM_IN: "zoom-in",
    ZOOM_OUT: "zoom-out",
    RESET_VIEW: "reset-view",
    PRINT: "print",
  },

  /*
  ================================================================
  TYPES TECHNIQUES D’ENTITÉS DESSINÉES
  ================================================================
  */
  entityTypes: {
    ASSET_ENVELOPE: "ASSET_ENVELOPE",
    AREA_RECT: "AREA_RECT",
    AREA_POLYLINE: "AREA_POLYLINE",
    LINE: "LINE",
    CIRCLE: "CIRCLE",
    ARC: "ARC",
  },

  /*
  ================================================================
  PARAMÈTRES PAR DÉFAUT DU COMPOSANT
  ================================================================
  */
  defaults: {
    width: "100%",
    height: 680,

    showToolbar: true,
    showFloorBar: true,
    showPropertiesPanel: true,
    showGrid: true,

    enablePersistence: true,
    enablePrint: true,

    readOnlyMode: false,
    disabled: false,

    assetLabel: "Asset",
    printTitle: "Spatial Plan",
    printOrientation: "landscape",

    defaultFloorId: null,

    minZoom: 0.4,
    maxZoom: 4,
    zoomStep: 0.15,
    defaultZoom: 1,

    defaultOffsetX: 0,
    defaultOffsetY: 0,

    gridSize: 20,
    gridMinorFactor: 1,
    gridMajorEvery: 5,

    gridPresets: [
      { label: "1 m", value: 20 },
      { label: "0.5 m", value: 10 },
      { label: "0.1 m", value: 2 },
    ],

    defaultSnapToGrid: true,

    selectionStrokeWidth: 2,
    shapeStrokeWidth: 1.25,
    hitStrokeWidth: 10,
    handleSize: 8,

    copyOffsetX: 20,
    copyOffsetY: 20,

    defaultFloorLabel: "Ground Floor",
    defaultFloorElevation: 0,
  },

  /*
  ================================================================
  IMPRESSION
  ================================================================
  */
  print: {
    formats: {
      A4: "A4",
    },
    orientations: {
      PORTRAIT: "portrait",
      LANDSCAPE: "landscape",
    },
    defaultFormat: "A4",
    defaultOrientation: "landscape",
    pagePadding: 18,
  },

  /*
  ================================================================
  LIBELLÉS UI
  ================================================================
  */
  floor: {
    defaultOrder: 1,
    emptyLabel: "No level loaded",
  },

  labels: {
    toolbar: "Tools",
    floor: "Level",
    elevation: "Elevation",
    properties: "Properties",
    empty: "No drawing data",
    noSelection: "No selection",
  },

  /*
  ================================================================
  ENDPOINTS API
  ================================================================
  */
  api: {
    viewsEndpoint: "/api/spatial/views",
    entitiesEndpoint: "/api/spatial/entities",
  },

  /*
  ================================================================
  STYLES PAR DÉFAUT DES TYPES TECHNIQUES DE SHAPES
  ================================================================
  */
  shapeDefaults: {
    ASSET_ENVELOPE: { fillOpacity: 0.08 },
    AREA_RECT: { fillOpacity: 0.16 },
    AREA_POLYLINE: { fillOpacity: 0.16 },
    LINE: { fillOpacity: 0 },
    CIRCLE: { fillOpacity: 0.16 },
    ARC: { fillOpacity: 0 },
  },

  /*
  ================================================================
  PALETTES MÉTIER PAR MODE / TYPE LOGIQUE
  ================================================================

  Objectif :
  - Ouvrage  -> bleu
  - Level    -> orange / bronze
  - Area     -> vert / teal

  Ces palettes seront utilisées dans le viewport pour donner
  une lecture visuelle immédiate du type d’objet créé.
  */
  palettes: {
    ouvrage: {
      stroke: "#164D63",
      fill: "rgba(22,77,99,0.15)",
      previewFill: "rgba(22,77,99,0.08)",
      previewStroke: "#164D63",
      selectedStroke: "#164D63",
    },

    level: {
      stroke: "#B8621B",
      fill: "rgba(184,98,27,0.15)",
      previewFill: "rgba(184,98,27,0.08)",
      previewStroke: "#B8621B",
      selectedStroke: "#B8621B",
    },

    area: {
      stroke: "#1A8C74",
      fill: "rgba(26,140,116,0.15)",
      previewFill: "rgba(26,140,116,0.08)",
      previewStroke: "#1A8C74",
      selectedStroke: "#1A8C74",
    },
  },
};

export default drawSpaceConfig;
